import EventStack from './EventStack';

const instance = new EventStack();

export default instance;
